module.exports = __webpack_public_path__ + "img/games-11.dfc3dfda.webp";